import "./AboutDiscoveryPage2.module.css";
import Header from "@/reusable_sections/Header";
import OurMission from "./sections/OurMission";
import MarketInsights from "./sections/MarketInsights";
import Footer from "@/reusable_sections/Footer";
export default function AboutDiscoveryPage2() {
  return <div>
      <Header />
      <OurMission />
      <MarketInsights />
      <Footer />
    </div>;
}